import React from 'react';
import styled from 'styled-components';

const RootContainer = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
`;

const BackgroundContainer = styled.div`
  width: 100%;
  position: relative;
  top: 32px;
  z-index: 1;
`;

const Background = ({ themeColor }: any) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1881.5 1432.7">
    <defs>
      <clipPath id="m">
        <path d="M0 1500h1500V0H0z" />
      </clipPath>
      <clipPath id="j">
        <path d="M1451.7 729.73h-211.92v7.696h211.92z" />
      </clipPath>
      <linearGradient
        id="b"
        x2="1"
        gradientTransform="matrix(211.91 0 0 -211.91 1239.8 733.58)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#282827" />
        <stop offset="0.427" stopColor="#c7c7c7" />
        <stop offset="0.546" stopColor="#c7c7c7" />
        <stop offset="0.937" stopColor="#515050" />
        <stop offset="1" stopColor="#515050" />
      </linearGradient>
      <clipPath id="i">
        <path d="M1451.7 292.78h-211.92v7.696h211.92z" />
      </clipPath>
      <linearGradient
        id="a"
        x2="1"
        gradientTransform="matrix(211.91 0 0 -211.91 1239.8 296.63)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#282827" />
        <stop offset="0.427" stopColor="#c7c7c7" />
        <stop offset="0.546" stopColor="#c7c7c7" />
        <stop offset="0.937" stopColor="#515050" />
        <stop offset="1" stopColor="#515050" />
      </linearGradient>
      <clipPath id="s">
        <path d="M183.96 559.63H95.208l-5.535 98.9h98.9z" />
      </clipPath>
      <linearGradient
        id="h"
        x2="1"
        gradientTransform="matrix(0 98.9 98.9 0 139.12 559.63)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#a0a0a0" />
        <stop offset="0.23" stopColor="#fff" />
        <stop offset="1" stopColor="#fff" />
      </linearGradient>
      <clipPath id="r">
        <path d="M183.96 488.96H95.208l-5.535 98.9h98.9z" />
      </clipPath>
      <linearGradient
        id="g"
        x2="1"
        gradientTransform="matrix(0 98.9 98.9 0 139.12 488.96)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#a0a0a0" />
        <stop offset="0.23" stopColor="#fff" />
        <stop offset="1" stopColor="#fff" />
      </linearGradient>
      <clipPath id="q">
        <path d="M183.96 420.19H95.208l-5.535 98.9h98.9z" />
      </clipPath>
      <linearGradient
        id="f"
        x2="1"
        gradientTransform="matrix(0 98.9 98.9 0 139.12 420.19)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#a0a0a0" />
        <stop offset="0.23" stopColor="#fff" />
        <stop offset="1" stopColor="#fff" />
      </linearGradient>
      <clipPath id="p">
        <path d="M183.96 349.75H95.208l-5.535 98.9h98.9z" />
      </clipPath>
      <linearGradient
        id="e"
        x2="1"
        gradientTransform="matrix(0 98.9 98.9 0 139.12 349.75)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#a0a0a0" />
        <stop offset="0.23" stopColor="#fff" />
        <stop offset="1" stopColor="#fff" />
      </linearGradient>
      <clipPath id="o">
        <path d="M325.81 1138.5s102-64 102-186v-444h635v444c0 122 103 186 103 186z" />
      </clipPath>
      <linearGradient
        id="d"
        x2="1"
        gradientTransform="matrix(3.1004 839.99 839.99 -3.1004 743.68 563.13)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#e5e4e3" />
        <stop offset="0.179" stopColor="#e5e4e3" />
        <stop offset="0.545" stopColor="#e5e4e3" />
        <stop offset="0.746" stopColor="#787878" />
        <stop offset="0.948" stopColor="#323232" />
        <stop offset="1" stopColor="#323232" />
      </linearGradient>
      <clipPath id="n">
        <path d="M0 1500h1500V0H0z" />
      </clipPath>
      <clipPath id="l">
        <path d="M0 1500h1500V0H0z" />
      </clipPath>
      <clipPath id="k">
        <path d="M934.75 739.81H556.87v212.56h377.88z" />
      </clipPath>
      <linearGradient
        id="c"
        x2="1"
        gradientTransform="scale(378.6 -378.6) rotate(33.01 4.984 1.433)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#282827" />
        <stop offset="0" stopColor="#282827" />
        <stop offset="0.036" stopColor="#282827" />
        <stop offset="0.154" stopColor="#797979" />
        <stop offset="0.165" stopColor="#797979" />
        <stop offset="0.291" stopColor="#c7c7c7" />
        <stop offset="0.412" stopColor="#797979" />
        <stop offset="0.552" stopColor="#282827" />
        <stop offset="0.634" stopColor="#282827" />
        <stop offset="0.754" stopColor="#282827" />
        <stop offset="0.863" stopColor="#b3b3b4" />
        <stop offset="0.972" stopColor="#646565" />
        <stop offset="1" stopColor="#646565" />
      </linearGradient>
    </defs>
    <path
      fill="#e5e4e3"
      d="M0 0h-487.63l-247.02-336H160.6l2.668 112.64z"
      transform="matrix(1.3333 0 0 -1.3333 -59.249 1718.7) translate(990.34 610.82)"
    />
    <path
      fill="#d8d7d6"
      d="M998.81 244.2H256.04v30.61h742.77z"
      transform="matrix(1.3333 0 0 -1.3333 -59.249 1718.7)"
    />
    <g
      clipPath="url(#m)"
      transform="matrix(1.3333 0 0 -1.3333 -59.249 1718.7)"
    >
      <path
        fill="#d8d7d6"
        d="M0 0s142 .682 216 64.682 344.79 47.958 344.79 47.958l.207-112.96v-30h-561z"
        transform="translate(592.81 274.81)"
      />
      <path
        fill="#fff"
        d="M0 0s142 .682 216 64.682 346.79 53.958 346.79 53.958l.207-118.96v-30h-563z"
        transform="translate(592.81 244.81)"
      />
    </g>
    <path
      fill={themeColor || '#ffd662'}
      d="M1445.8 299.73h-200v430h200z"
      transform="matrix(1.3333 0 0 -1.3333 -59.249 1718.7)"
    />
    <g
      clipPath="url(#j)"
      transform="matrix(1.3333 0 0 -1.3333 -59.249 1718.7)"
    >
      <path fill="url(#b)" d="M1451.7 729.73h-211.92v7.696h211.92z" />
    </g>
    <path
      fill="#282827"
      d="M1240.2 726.03h-3.83v15.096h3.83z"
      transform="matrix(1.3333 0 0 -1.3333 -59.249 1718.7)"
    />
    <path
      fill="#515050"
      d="M1455.6 726.03h-3.829v15.096h3.829z"
      transform="matrix(1.3333 0 0 -1.3333 -59.249 1718.7)"
    />
    <g
      clipPath="url(#i)"
      transform="matrix(1.3333 0 0 -1.3333 -59.249 1718.7)"
    >
      <path fill="url(#a)" d="M1451.7 292.78h-211.92v7.696h211.92z" />
    </g>
    <path
      fill="#282827"
      d="M1240.2 289.08h-3.83v15.096h3.83z"
      transform="matrix(1.3333 0 0 -1.3333 -59.249 1718.7)"
    />
    <path
      fill="#515050"
      d="M1455.6 289.08h-3.829v15.096h3.829z"
      transform="matrix(1.3333 0 0 -1.3333 -59.249 1718.7)"
    />
    <path
      fill="#404041"
      d="M0 0h-158.63l14.76 378.74h130.96z"
      transform="matrix(1.3333 0 0 -1.3333 -59.249 1718.7) translate(218.71 294.26)"
    />
    <path
      fill="#bbbdbf"
      d="M0 0h-111.58l-9.226 378.74h130.96z"
      transform="matrix(1.3333 0 0 -1.3333 -59.249 1718.7) translate(195.64 294.26)"
    />
    <g
      clipPath="url(#s)"
      transform="matrix(1.3333 0 0 -1.3333 -59.249 1718.7)"
    >
      <path fill="url(#h)" d="M183.96 559.63H95.208l-5.535 98.9h98.9z" />
    </g>
    <g
      clipPath="url(#r)"
      transform="matrix(1.3333 0 0 -1.3333 -59.249 1718.7)"
    >
      <path fill="url(#g)" d="M183.96 488.96H95.208l-5.535 98.9h98.9z" />
    </g>
    <g
      clipPath="url(#q)"
      transform="matrix(1.3333 0 0 -1.3333 -59.249 1718.7)"
    >
      <path fill="url(#f)" d="M183.96 420.19H95.208l-5.535 98.9h98.9z" />
    </g>
    <g
      clipPath="url(#p)"
      transform="matrix(1.3333 0 0 -1.3333 -59.249 1718.7)"
    >
      <path fill="url(#e)" d="M183.96 349.75H95.208l-5.535 98.9h98.9z" />
    </g>
    <path
      fill="#404041"
      d="M233.81 287.08H44.44v14.368h189.37z"
      transform="matrix(1.3333 0 0 -1.3333 -59.249 1718.7)"
    />
    <g
      clipPath="url(#o)"
      transform="matrix(1.3333 0 0 -1.3333 -59.249 1718.7)"
    >
      <path
        fill="url(#d)"
        d="M325.81 1138.5s102-64 102-186v-444h635v444c0 122 103 186 103 186z"
      />
    </g>
    <g
      clipPath="url(#n)"
      transform="matrix(1.3333 0 0 -1.3333 -59.249 1718.7)"
    >
      <path
        fill={themeColor || '#ffd662'}
        d="M0 0h-840v22.468C-840 34.912-829.912 45-817.468 45h794.94C-10.084 45 .004 34.912.004 22.468z"
        transform="translate(1165.8 1138.5)"
      />
      <path
        fill="#f7f7f7"
        d="M0 0h-808v8.83c0 6.721 5.449 12.17 12.17 12.17h783.04C-5.729 21-.003 15.275-.003 8.212z"
        transform="translate(1149.8 1150.5)"
      />
      <path
        fill={themeColor || '#ffd662'}
        d="M0 0h-635v-158H0z"
        transform="translate(1063 666)"
      />
      <path
        fill={themeColor || '#ffd662'}
        d="M0 0s172.26 8 299.26 73 188.81 48.553 188.81 48.553l.191-121.55z"
        transform="translate(574.94 661)"
      />
    </g>
    <g
      clipPath="url(#l)"
      transform="matrix(1.3333 0 0 -1.3333 -59.249 1718.7)"
    >
      <path
        fill={themeColor || '#ffd662'}
        d="M0 0h-190.79c-38.023 0-68.848 30.823-68.848 68.847v190.79H.002z"
        transform="translate(1106.5 244.28)"
      />
      <path
        fill={themeColor || '#f9db7a'}
        d="M0 0h-234.83l-12.403-19.018h259.64z"
        transform="translate(1094.1 522.93)"
      />
      <path
        fill="#fff"
        d="M0 0v165.08l8.233 18.987h145.27l10.687-18.987V0z"
        transform="translate(894.59 343.3)"
      />
      <path fill="#eaeaea" d="M1058.8 341.53H894.61v166.85h164.19z" />
    </g>
    <g
      clipPath="url(#k)"
      transform="matrix(1.3333 0 0 -1.3333 -59.249 1718.7)"
    >
      <path fill="url(#c)" d="M934.75 739.81H556.87v212.56h377.88z" />
    </g>
    <path
      fill="none"
      stroke="#59595c"
      strokeMiterlimit="10"
      strokeWidth="7"
      d="M934.75 739.81H556.87v212.56h377.88z"
      transform="matrix(1.3333 0 0 -1.3333 -59.249 1718.7)"
    />
    <path
      fill="#fff"
      stroke={themeColor || '#efc459'}
      strokeMiterlimit="10"
      strokeWidth="7"
      d="M1037.7 1071.9H453.96v213.56h583.74z"
      transform="matrix(1.3333 0 0 -1.3333 -59.249 1718.7)"
    />
  </svg>
);

export interface BoothBackgroundProps {
  themeColor?: string;
}

const BoothBackground: React.FC<BoothBackgroundProps> = ({ themeColor }: BoothBackgroundProps) => (
  <RootContainer>
    <BackgroundContainer>
      <Background themeColor={themeColor} />
    </BackgroundContainer>
  </RootContainer>
);

export default BoothBackground;
